export default "__VITE_ASSET__59ac2ae3__"